export const fieldNames = {
  ethereumAddress: 'ethereumAddress',
};

export default {
  [fieldNames.ethereumAddress]: {
    presence: true,
    ethereumAddress: true,
  },
};



// WEBPACK FOOTER //
// ./src/ui/users/set-eth-address/model.js